export default __webpack_public_path__ + "static/media/041-bomb.e58a7c5c.png";